'use strict';

var baseSearch = require('pluggin_variable_weight/search/search');

/**
 * Override: Abrir panel lateral de filtros mediante clase CSS (animación slide-in)
 */
baseSearch.filter = function () {
    $('.container').on('click', 'button.filter-results', function () {
        $('.refinement-bar').addClass('is-open').attr('aria-hidden', false);
        $('.modal-background').addClass('is-open');
        $('.refinement-bar .close').first().focus();
    });
};

/**
 * Override: Cerrar panel lateral de filtros
 */
baseSearch.closeRefinements = function () {
    $(document).on('click', '.refinement-bar button.close, .refinement-bar button.apply-filters, .modal-background', function () {
        $('.refinement-bar').removeClass('is-open').attr('aria-hidden', true);
        $('.modal-background').removeClass('is-open');
        $('button.filter-results').focus();
    });
};

/**
 * Override: Cerrar panel al redimensionar ventana
 */
baseSearch.resize = function () {
    $(window).on('resize', function () {
        $('.refinement-bar').removeClass('is-open').attr('aria-hidden', true);
        $('.modal-background').removeClass('is-open');
    });
};

/**
 * Keep the filter/sort toolbar (.filter-controls-bar) stuck right below the
 * header AND the categories menu (rendered as a separate "main-menu"
 * component, sibling to <header>, not nested inside it) while scrolling the
 * PLP, by updating the --header-sticky-offset CSS variable used as its
 * sticky "top". Both elements are re-measured on scroll/resize since their
 * height/position can change (fixed on desktop, hide-on-scroll header on
 * mobile, promo bar visibility, etc.).
 */
baseSearch.stickyFilterBar = function () {
    var $header = $('header');
    // ".main-menu" collapses to ~0 height on desktop (its only child is
    // position:fixed), so measure the actual fixed nav bar directly.
    var $categoryNav = $('.main-menu nav.bg-inverse');
    var $toolbar = $('.filter-controls-bar');

    if (!$header.length || !$toolbar.length) {
        return;
    }

    var ticking = false;

    function updateOffset() {
        var offset = $header[0].getBoundingClientRect().bottom;

        if ($categoryNav.length && $categoryNav.is(':visible')) {
            offset = Math.max(offset, $categoryNav[0].getBoundingClientRect().bottom);
        }

        offset = Math.max(offset, 0);
        document.documentElement.style.setProperty('--header-sticky-offset', offset + 'px');
        ticking = false;
    }

    function requestUpdate() {
        if (!ticking) {
            window.requestAnimationFrame(updateOffset);
            ticking = true;
        }
    }

    updateOffset();
    $(window).on('scroll', requestUpdate);
    $(window).on('resize load', requestUpdate);
};

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    // Some selectors (e.g. recommendation slots) are rendered only on full
    // page load and are never part of this Ajax fragment; skip them instead
    // of wiping out the existing content on the page.
    if ($updates.length) {
        $(selector).empty().html($updates.html());
    }
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * Override: Parse Ajax results from refinement selection or sort change.
 * Also refreshes the sort order select (options + selected state) so
 * filters and sort order stay in sync with each other, no matter which
 * one is changed first.
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);

    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        // Exclude recommender carousels: they also carry the "product-grid"
        // class for column styling, so a plain ".product-grid" selector
        // would overwrite the recommendations-plp carousel content too.
        '.product-grid:not(.carousel-wrapper)',
        '.show-more',
        '.filter-bar',
        '.sort-order'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    handleRefinements($results);
}

/**
 * Override: Handle refinement value selection and reset click, keeping the
 * sort order select in sync with the newly applied filters.
 */
baseSearch.applyFilter = function () {
    $('.container').on(
        'click',
        '.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button',
        function (e) {
            e.preventDefault();
            e.stopPropagation();

            $.spinner().start();
            $(this).trigger('search:filter', e);
            $.ajax({
                url: $(this).data('href'),
                data: {
                    page: $('.grid-footer').data('page-number'),
                    selectedUrl: $(this).data('href')
                },
                method: 'GET',
                success: function (response) {
                    parseResults(response);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    );
};

/**
 * Override: Handle sort order menu selection using the same full-fragment
 * endpoint/parsing as applyFilter, so the currently selected filters are
 * preserved when the shopper changes the sort order.
 */
baseSearch.sort = function () {
    $('.container').on('change', '[name=sort-order]', function (e) {
        e.preventDefault();

        $.spinner().start();
        $(this).trigger('search:sort', this.value);
        $.ajax({
            url: this.value,
            data: { selectedUrl: this.value },
            method: 'GET',
            success: function (response) {
                parseResults(response);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
};

module.exports = baseSearch;

/* Lightweight carousel initializer for recommender carousels (.carousel-container).
   Recommendation slots are often rendered via a remote include and can
   populate their slides slightly after the surrounding page markup, so
   containers with no slides yet are retried for a short while instead of
   being skipped permanently. Safe to call multiple times: already bound
   containers are marked with a data flag and skipped. */
function reinitCarousels() {
    $('.carousel-container').each(function () {
        var $container = $(this);
        if ($container.data('carousel-init')) {
            return;
        }

        var $wrapper = $container.find('.carousel-wrapper');
        var $slides = $wrapper.find('.carousel-slide');
        var $btnPrev = $container.find('.carousel-button-prev');
        var $btnNext = $container.find('.carousel-button-next');

        if (!$wrapper.length || !$slides.length) {
            var attempts = $container.data('carousel-attempts') || 0;
            if (attempts < 30) {
                $container.data('carousel-attempts', attempts + 1);
                setTimeout(reinitCarousels, 150);
            }
            return;
        }

        $container.data('carousel-init', true);

        function slideWidth() {
            return $wrapper.find('.carousel-slide').outerWidth(true) || 0;
        }

        function animate(direction) {
            var w = slideWidth();
            $btnPrev.prop('disabled', true);
            $btnNext.prop('disabled', true);

            if (direction === 'next') {
                $wrapper.css({ transition: 'transform 0.45s ease', transform: 'translateX(-' + w + 'px)' });
                setTimeout(function () {
                    $wrapper.css('transition', 'none');
                    var $first = $wrapper.find('.carousel-slide').first();
                    $wrapper.append($first);
                    $wrapper.css('transform', 'translateX(0)');
                    $btnPrev.prop('disabled', false);
                    $btnNext.prop('disabled', false);
                }, 500);
            } else {
                var $last = $wrapper.find('.carousel-slide').last();
                $wrapper.prepend($last);
                $wrapper.css({ transition: 'none', transform: 'translateX(-' + w + 'px)' });
                // allow layout to settle
                setTimeout(function () {
                    $wrapper.css({ transition: 'transform 0.45s ease', transform: 'translateX(0)' });
                }, 20);
                setTimeout(function () {
                    $btnPrev.prop('disabled', false);
                    $btnNext.prop('disabled', false);
                }, 500);
            }
        }

        $btnNext.off('click.reinit').on('click.reinit', function () { animate('next'); });
        $btnPrev.off('click.reinit').on('click.reinit', function () { animate('prev'); });
    });
}

// Recommendation carousels are rendered once with the full page (they are
// not part of the search filter/sort Ajax fragment), so binding them once
// on page load is enough; the retry loop above covers content that loads
// slightly later via a remote include.
$(document).ready(function () {
    reinitCarousels();
});
